import { useState } from "react";

type TResult = [boolean, () => void, () => void];

const useModal = (): TResult => {
  const [visible, setVisible] = useState(false);

  const showModal = () => setVisible(true);
  const closeModal = () => setVisible(false);

  return [visible, showModal, closeModal];
};

export default useModal;
